module.exports = __webpack_public_path__ + "media/newstyle/images/word-message-ba8253474663e390689f868f732306fd.svg";